import { type Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const tourRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/tour-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () => import('./details/tour-details.component'),
    title: 'PAGES.TOUR.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/tour-details.component'),
    title: 'PAGES.TOUR.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
